import { createContext } from 'react';

export interface ConsentContextType {
  /** The ad origin may be captured and sent here (not white-label, not a booking page). */
  trackingScope: boolean;
  /** In scope and a pixel ID is configured: the banner and the Pixel are available. */
  bannerEnabled: boolean;
  bannerVisible: boolean;
  /** The banner was opened from the footer and shows the categories. */
  settingsOpen: boolean;
  /** The stored decision; false when there is none. */
  marketing: boolean;
  /** The Pixel is loaded and may send events. */
  marketingActive: boolean;
  accept: () => void;
  decline: () => void;
  saveSettings: (marketing: boolean) => void;
  openSettings: () => void;
  /** The close button: declines without a decision, otherwise just closes. */
  dismiss: () => void;
}

const noop = () => undefined;

// Without a provider (tests, isolated pages) nothing is tracked.
export const DEFAULT_CONSENT: ConsentContextType = {
  trackingScope: false,
  bannerEnabled: false,
  bannerVisible: false,
  settingsOpen: false,
  marketing: false,
  marketingActive: false,
  accept: noop,
  decline: noop,
  saveSettings: noop,
  openSettings: noop,
  dismiss: noop,
};

export const ConsentContext = createContext<ConsentContextType>(DEFAULT_CONSENT);
